/* ============================================================================
   CLARA CART BRIDGE  (assets/clark-cart-bridge.js)
   ----------------------------------------------------------------------------
   Connects the CLARK cart drawer to the rest of the CLARA theme:

   1. The header cart icon (.js-toggle-cart) opens the CLARK drawer instead of
      the theme's built-in mini cart.
   2. Every successful add to cart made by the theme or an app (product page,
      sticky Add to Cart, quick view, "+ Add to Cart" on product cards, ...)
      opens the CLARK drawer. Detected at network level (XHR + fetch), so it
      works for every add button without editing the theme's own JavaScript.
   3. After any cart change it asks clark-cart-upsells.js to re-check the
      automatic free gift.

   Needs window.DrawerCart (snippets/clark-cart-drawer.liquid).
   ============================================================================ */
(function () {
  'use strict';
  if (window.__clarkBridgeInit) return;
  window.__clarkBridgeInit = true;

  var CART_ADD = /\/cart\/add(\.js)?(\?|$)/;
  var CART_MUTATE = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/;

  function isCartPage() {
    return !!(document.body && document.body.classList.contains('template-cart'));
  }

  /* 1. header cart icon -> CLARK drawer (capture phase: runs before the theme's own handler) */
  document.addEventListener('click', function (e) {
    var t = e.target.closest ? e.target.closest('.js-mini-cart .js-toggle-cart') : null;
    if (!t || !window.DrawerCart) return;
    e.preventDefault();
    e.stopPropagation();
    window.DrawerCart.open();
  }, true);

  /* 2 + 3. react to successful cart requests */
  function onCartChanged(url) {
    if ((window.__clarkSilent || 0) > 0) return; /* our own requests handle themselves */
    setTimeout(function () {
      if (CART_ADD.test(url) && !isCartPage() && window.DrawerCart) window.DrawerCart.open();
      if (window.ClarkUpsells && typeof window.ClarkUpsells.checkGift === 'function') window.ClarkUpsells.checkGift();
    }, 60);
  }

  /* XMLHttpRequest (jQuery $.ajax - the theme's add to cart buttons) */
  if (window.XMLHttpRequest) {
    var xhrOpen = XMLHttpRequest.prototype.open;
    var xhrSend = XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.open = function (method, url) {
      this.__clarkMethod = String(method || 'GET').toUpperCase();
      this.__clarkUrl = String(url || '');
      return xhrOpen.apply(this, arguments);
    };
    XMLHttpRequest.prototype.send = function () {
      var xhr = this;
      if (xhr.__clarkMethod === 'POST' && CART_MUTATE.test(xhr.__clarkUrl)) {
        xhr.addEventListener('load', function () {
          if (xhr.status >= 200 && xhr.status < 300) onCartChanged(xhr.__clarkUrl);
        });
      }
      return xhrSend.apply(this, arguments);
    };
  }

  /* fetch (inline add button script in theme.liquid, drawer quantity buttons, apps) */
  if (window.fetch) {
    var nativeFetch = window.fetch;
    window.fetch = function (input, init) {
      var url = typeof input === 'string' ? input : ((input && input.url) || '');
      var method = String((init && init.method) || (input && input.method) || 'GET').toUpperCase();
      var p = nativeFetch.apply(this, arguments);
      if (method === 'POST' && CART_MUTATE.test(url)) {
        p.then(function (res) { if (res && res.ok) onCartChanged(url); }).catch(function () {});
      }
      return p;
    };
  }
})();
